import Hero1 from './Hero1';
import './index.css'

export default Hero1